// extracted by mini-css-extract-plugin
export default {"minDesktop":"1024px","skeleton-progress":"_3XBFJ"};